export default __webpack_public_path__ + "static/media/6-Inam-Kan du utrykke ulike sider ved din identitet i Norge.071c74b2.mp4";